export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      return `fornecedor.nome like '%${searchText}%' or produto like '%${searchText}%' or codigoInterno like '%${searchText}%'`;
    }
    return '';
  },
};
